const GameConfigReducers = (state = {}, action) => {
  switch (action.type) {
    case "storeGameConfig":
      return action.payload;
    case "clearGameConfig":
      return (state = {});
    default:
      return state;
  }
};
export default GameConfigReducers;
